import React, { Component } from "react";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import UserTypeContainer from "../../users/UserTypeContainer";
import {
  usersSelector,
  usersIsLoadingSelector,
} from "../../../../modules/reports/users/Selectors";
import Spinner from "../../../../components/UI/Misc/Spinner";
import { Link } from "react-router-dom";

const Content = () => {
  const { users, isLoading } = useSelector((state) => ({
    users: usersSelector(state),
    isLoading: usersIsLoadingSelector(state),
  }));

  return (
    <CardContainer>
      {isLoading && (
        <SpinnerContainer>
          {" "}
          <Spinner />{" "}
        </SpinnerContainer>
      )}
      <Header>
        <div className='font-weight-bold'>Name</div>
        <div className='font-weight-bold'>Email</div>
        <div className='font-weight-bold'>Phone</div>
        <div className='font-weight-bold'>User Type</div>
        <div className='font-weight-bold'>Email Verified</div>
        <div className='font-weight-bold'>Status</div>
      </Header>

      {!isLoading && (!users || users.length === 0) && (
        <div className='kt-widget31__item'>
          <NoItems className='kt-widget31__text'>No items.</NoItems>
        </div>
      )}
      {users.map((user) => (
        <Card key={user._id}>
          <div>
            <Link to={`reports/users/${user._id}`}>
              {user.firstName} {user.lastName}
            </Link>
          </div>
          <div>{user.email}</div>
          <div>{user.phone}</div>
          <div>
            <UserTypeContainer userTypes={user.userType} />
          </div>
          <div>
            <span className='font-weight-bold'>
              {user.emailVerified ? "Verified" : "Not Verified"}
            </span>
          </div>
          <div>
            <span className='font-weight-bold'>
              {user.status ? "Active" : "Not Active"}
            </span>
          </div>
        </Card>
      ))}
    </CardContainer>
  );
};

class ReportsContent extends Component {
  render() {
    return <Content />;
  }
}

export default ReportsContent;

const Card = styled.div`
  background-color: #fff;
  display: inline-grid;
  text-align: center;
  padding: 14px 0px;
  border-bottom: 1px solid #ccc;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
`;

const Header = styled.div`
  background-color: #fff;
  display: inline-grid;
  text-align: center;
  padding: 14px 0px;
  border: 1px solid #000;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
`;

const CardContainer = styled.div`
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px;
  grid-gap: 3px 3px;
  margin: 2px;
`;

const NoItems = styled.p`
  margin: 0;
  font-size: 18px;
  text-align: center;
  width: 100%;
  font-weight: bold;
  opacity: 0.5;
`;

const SpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
`;
